import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Vehicle } from "../../shared/domain/vehicle";
import { ModalDirective } from "ngx-bootstrap";
import { EnvironmentService } from '@nw/ui-core-shared/services';

@Component({
  selector: 'nw-vehicle-remove',
  templateUrl: './vehicle-remove.component.html'
})
export class VehicleRemoveComponent implements OnInit {

  @ViewChild('removeVehicleModal') modal: ModalDirective;
  @Output() initModal: EventEmitter<any> = new EventEmitter();
  @Output() removeVehicle: EventEmitter<any> = new EventEmitter();
  @Input() vehicle: Vehicle;
  @Input() isRemoving: boolean = false;

  imgCdn;

  constructor(private environmentService: EnvironmentService) {
  }

  ngOnInit() {
    this.imgCdn = this.environmentService.getEnvironment().utilPath.imagesCdn;
    this.initModal.emit(this.modal);
  }

  onRemove(){
    this.removeVehicle.emit(this.vehicle.nwVehicleId);
  }
}



// WEBPACK FOOTER //
// ./node_modules/@nw/ui-watchlist/components/vehicle-remove/vehicle-remove.component.ts